import React, {useContext} from 'react';
import { AppContext } from '../AppContext';
import ReactDOM from "react-dom";

class ToolbarPlaceholder extends React.Component {
    AdminBar = null;

    constructor(props) {
        super(props);
        this.state = {
            AdminBar: null,
        };
        this.toolbarElement = null;
    }

    get toolbarHost() {
        return document.getElementById('Toolbar-Wrapper');
    }

    _getVisitor() {
        return this.props?.context?.visitor;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!(this._getVisitorPermissions() > 3)) {
            this.toolbarElement = null;
            if (this.toolbarHost) {
                this.toolbarHost.remove();
            }
            return;
        }
        if (this.toolbarElement) {
            return;
        }
        let { AdminBar } = this.state;
        if (AdminBar) {
            this.toolbarElement = ( <AdminBar /> );
            return;
        }
        import('../layout/AdminBar')
            .then(module => {
                AdminBar = module.default;
                this.setState({
                    AdminBar,
                });
                window._Admin = module.AdminBar; // Expose module for static method calls
                if (!this.toolbarHost) {
                    const toolbarHost = document.createElement('div');
                    toolbarHost.id = 'Toolbar-Wrapper';
                    const headerElement = document.querySelector('header');
                    headerElement.insertBefore(toolbarHost, headerElement.firstChild);
                }
                this.toolbarElement = ( <AdminBar /> );
            })
            .catch(err => {
                console.error("Failed to load the admin component", err);
            });
    }

    _getVisitorPermissions() {
        const permissions = this._getVisitor()?.account?.permissions;
        if (permissions) {
            return parseInt(permissions, 10);
        }
        return null;
    }

    render() {
        if (!this.toolbarHost) {
            return null;
        }
        return ReactDOM.createPortal(this.toolbarElement, this.toolbarHost);
    }
}

function ToolbarPlaceholderWithContext(props) {
    const context = useContext(AppContext);
    return (<ToolbarPlaceholder {...props} context={context} />);
}

export default ToolbarPlaceholderWithContext;
